// @ts-nocheck
import tailwindAnimate from "tailwindcss-animate";
import tailwindRadix from "tailwindcss-radix";
import tailwindTextRendering from "tailwindcss-text-rendering";
import tailwindContainerQueries from "@tailwindcss/container-queries";
import tailwindForms from "@tailwindcss/forms";

const config = {
  content: ["./index.html", "./src/**/*.{js,ts,jsx,tsx}"],
  theme: {
    fontSize: {
      xxs: ["0.75rem", { lineHeight: "1.333", letterSpacing: "0.015rem" }],
      xs: ["0.813rem", { lineHeight: "1.23", letterSpacing: "0.016rem" }],
      sm: ["0.875rem", { lineHeight: "1.42", letterSpacing: "0.018rem" }],
      md: ["1rem", { lineHeight: "1.25", letterSpacing: "0.02rem" }],
      lg: ["1.125rem", { lineHeight: "1.33", letterSpacing: "0.023rem" }],
      xl: ["1.25rem", { lineHeight: "1.4", letterSpacing: "0.025rem" }],
      "display-xxs": [
        "1.25rem",
        { lineHeight: "1.2", letterSpacing: "-0.013rem" },
      ],
      "display-xs": [
        "1.5rem",
        { lineHeight: "1.16", letterSpacing: "-0.015rem" },
      ],
      "display-sm": [
        "1.875rem",
        { lineHeight: "1.2", letterSpacing: "-0.019rem" },
      ],
      "display-md": [
        "2.25rem",
        { lineHeight: "1.22", letterSpacing: "-0.023rem" },
      ],
      "display-lg": ["3rem", { lineHeight: "1.16", letterSpacing: "-0.03rem" }],
      "display-xl": [
        "3.75rem",
        { lineHeight: "1.2", letterSpacing: "-0.038rem" },
      ],
      "display-2xl": [
        "4.5rem",
        { lineHeight: "1.11", letterSpacing: "-0.045rem" },
      ],
    },
    fontWeight: {
      normal: "300",
      superNormal: "350",
      regular: "400",
      superRegular: "450",
      medium: "500",
      superMedium: "550",
      semibold: "600",
      bold: "700",
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1440px",
    },
    colors: {
      current: "currentColor",
      transparent: "transparent",
      white: "#ffffff",
      black: "#000000",
      "chorus-black": {
        100: "#353750",
        200: "#2B2D46",
        300: "#202239",
        400: "#1A1B2E",
        500: "#121321",
      },
      "chorus-orange": {
        50: "#FEF5EE",
        100: "#FDE9D7",
        200: "#FACEAE",
        300: "#F6AC7B",
        350: "#FF8D41",
        400: "#F27F45",
        500: "#EF652B",
        600: "#DF4417",
        700: "#B93215",
        800: "#942918",
        900: "#772417",
        950: "#40100A",
      },
      "chorus-blue": {
        // used for trip route/prediction lines
        50: "#F0F9FF",
        100: "#E0F2FE", // light surface tint (pairs with 600, like orange/yellow -100 callouts)
        200: "#BAE6FD",
        700: "#0369A1", // [3, 105, 161]
        600: "#0284C7", // [2, 133, 199]
        400: "#38BDF8", // [56, 190, 248]
        300: "#7DD3FC", // [125, 212, 252]
      },
      "chorus-teal": {
        50: "#F0FAFB",
        100: "#D9F1F4",
        200: "#B8E3E9",
        300: "#81CCD7",
        400: "#4FB1C1",
        500: "#3395A7",
        600: "#2D798D",
        700: "#2B6373",
        800: "#2A5260",
        900: "#274652",
        950: "#152D37",
      },
      "chorus-gray": {
        50: "#F7F7F8",
        100: "#F1F1F3",
        200: "#E9E9EC",
        300: "#DCDDE5",
        400: "#C6C7D2",
        500: "#AFB1C0",
        600: "#989AAE",
        700: "#8789A1",
        800: "#767893",
        900: "#676983",
      },
      "chorus-slate": {
        100: "#F1F5F9",
        200: "#E2E8F0",
        600: "#475569",
      },
      "chorus-red": {
        50: "#FEF2F3",
        100: "#FFE1E3",
        200: "#FFC9CC",
        300: "#FEA3A8",
        400: "#FB6E76",
        500: "#F2313C",
        600: "#E0222D",
        700: "#BD1821",
        800: "#9C1820",
        900: "#811B21",
        950: "#46090C",
      },
      "chorus-yellow": {
        50: "#FFFBEB",
        100: "#FEF3C7",
        200: "#FDE68A",
        300: "#FCD34D",
        400: "#FBBF24",
        500: "#F59E0B",
        600: "#D97706",
        700: "#B45309",
        800: "#92400E",
        900: "#78350F",
        950: "#451A03",
      },
      "chorus-green": {
        50: "#EEFFF1",
        100: "#D8FFE1",
        200: "#B4FEC5",
        300: "#79FC99",
        400: "#38F065",
        500: "#0DC93C",
        600: "#05B430",
        700: "#088D2A",
        800: "#0C6F26",
        900: "#0C5B22",
        950: "#00330F",
      },
      "chorus-bg": {
        gray: "#EDEDED",
      },
    },
    fontFamily: {
      sora: "Sora",
      manrope: "Manrope",
      mono: "JetBrains Mono",
    },
    extend: {
      backgroundImage: {
        "chorus-grad":
          "linear-gradient(270deg, rgba(241, 241, 243, 0.40) 0%, rgba(241, 241, 243, 0.60) 49.97%, rgba(241, 241, 243, 0.40) 100%)",
        "chorus-paging-grad":
          "linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 8%,rgba(255,255,255,1) 100%)",
        "chorus-grad-1":
          "linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,1) 8%,rgba(255,255,255,0) 100%)",
        "chorus-lr-fade":
          "linear-gradient(270deg, #FFF 15.63%, rgba(255, 255, 255, 0.00) 100%)",
        "chorus-rl-fade":
          "linear-gradient(to right, rgba(255,255,255,1) 15%,rgba(255,255,255,0) 100%)",
        "chrous-bt-fade":
          "linear-gradient(180deg, rgba(247, 247, 248, 0) 0%, rgba(247, 247, 248, 0.984375) 100%)",
        "chorus-nav-grad":
          "linear-gradient(180deg, rgba(241, 241, 243, 0) 0%, #F1F1F3 21%);",
      },
      boxShadow: {
        box: "0px 4px 12px rgba(10, 18, 28, 0.06), 0px 1px 4px rgba(10, 18, 28, 0.04)",
        focus: "0px 0px 0px 4px #D9F1F4",
        switch: "1px 1px 4px #C6C7D2",
        "switch-1": "-1px 1px 4px #369DB0",
        "focus-error": "0px 0px 0px 4px #FFE1E3",
        key: "0.5px 0.5px 3px #c6c7d2ac",
        "box-1": "1px 1px 4px #C6C7D2",
        "box-2":
          "0 12px 20px -2px rgba(32, 34, 57, 0.04), 0 6px 8px -4px rgba(32, 34, 57, 0.02)",
        "box-3": "0px 0px 6px 0px rgba(26, 29, 35, 0.04);",
        "box-4": "0px 12px 20px -2px #2022390A, 0px 6px 8px -4px #20223905",
        "circle-1": "0 0 0 3px rgba(32, 34, 57, 0.20)",
        "circle-2": "0 0 0 4px rgba(32, 34, 57, 0.20)",
        "circle-3": "0 0 0 5px rgba(32, 34, 57, 0.20)",
        "map-btn": "0px 1px 4px 0px #1018280A, 0px 4px 12px 0px #1018280F",
        "map-slide":
          "-4px 0px 20px -2px #1E293B05, -8px 0px 8px -4px #1E293B05",
        "mobile-nav": "0px 1px 4px 0px #1018280A, 0px 4px 12px 0px #1018280F",
      },
      keyframes: {
        "slide-down": {
          "0%": { opacity: "0", transform: "translateY(-10px)" },
          "100%": { opacity: "1", transform: "translateY(0)" },
        },
        "slide-up": {
          "0%": { opacity: "0", transform: "translateY(10px)" },
          "100%": { opacity: "1", transform: "translateY(0)" },
        },
        "slide-right": {
          "0%": { opacity: "0", transform: "translateX(-10px)" },
          "100%": { opacity: "1", transform: "translateX(0)" },
        },
        "slide-left": {
          "0%": { opacity: "0", transform: "translateX(10px)" },
          "100%": { opacity: "1", transform: "translateX(0)" },
        },
        "accordion-down": {
          from: { height: "0" },
          to: { height: "var(--radix-accordion-content-height)" },
        },
        "accordion-up": {
          from: { height: "var(--radix-accordion-content-height)" },
          to: { height: "0" },
        },
        "thinking-dot": {
          "0%, 100%": { opacity: "0.2", transform: "translateY(0)" },
          "50%": { opacity: "1", transform: "translateY(-1px)" },
        },
      },
      animation: {
        "slide-down": "slide-down 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
        "slide-up": "slide-up 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
        "slide-right": "slide-right 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
        "slide-left": "slide-left 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out",
        "thinking-dot": "thinking-dot 1.05s ease-in-out infinite",
        "thinking-dot-delay-1": "thinking-dot 1.05s ease-in-out 0.2s infinite",
        "thinking-dot-delay-2": "thinking-dot 1.05s ease-in-out 0.4s infinite",
      },
      spacing: {
        0.75: "0.188rem",
        1.25: "0.313rem",
        1.75: "0.438rem",
        3.25: "0.813rem",
        3.75: "0.938rem",
        4.25: "1.063rem",
        4.5: "1.125rem",
        5.5: "1.375rem",
        6.5: "1.625rem",
        7.5: "1.875rem",
        8.5: "2.125rem",
        9.5: "2.375rem",
        10.5: "2.625rem",
      },
      borderRadius: {
        7: "0.438rem",
        10: "0.625rem",
        18: "1.125rem",
        20: "1.25rem",
      },
      height: {
        17.5: "4.375rem",
      },
      width: {
        17.5: "4.375rem",
      },
    },
  },
  plugins: [
    tailwindAnimate,
    tailwindRadix,
    tailwindTextRendering,
    tailwindContainerQueries,
    tailwindForms,
  ],
};

export default config;
